module.exports = __webpack_public_path__ + "img/ec2.db6eca0b.jpg";